function GenericTitle({title, size = '5xl'}) {
    return (
        <p className={`mt-1 uppercase text-3xl font-extrabold text-gray-900 sm:text-4xl sm:tracking-wide lg:text-${size}`}>
            {title}
        </p>
    )
}

export default GenericTitle;